export default "__VITE_ASSET__2XaOuEku__"